import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {AppState} from '../../index';
import {NotificationService} from '../../../../services/notification.service';
import {
  actionInstitution,
  deleteInstitution,
  getAllInstitutions,
  loadInstitutions,
  upsertInstitution
} from './institution.actions';
import {map, switchMap} from 'rxjs/operators';
import {Apollo} from 'apollo-angular';
import {GET_INSTITUTION, SAVE_INSTITUTION} from './institution.graphql';
import {ActionTypeEnum} from '../../../../shared/enums/data.enums';
import {SettingsService} from 'src/app/services/settings.service';

@Injectable()
export class InstitutionEffects {

  get = createEffect(() => this.actions$.pipe(
    ofType(getAllInstitutions),
    switchMap(() => {
      return this.apollo.query({
        query: GET_INSTITUTION
      }).pipe(
        map(({ data }: any) => {
          const result: any = Object.values(data)[0];

          if (result !== null && result?.response?.code === 9000) {
            this.store.dispatch(loadInstitutions({institutions: result?.data}));
          }
        })
      );
    })
  ), { dispatch: false });

  save = createEffect(() => this.actions$.pipe(
    ofType(actionInstitution),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: SAVE_INSTITUTION,
        variables: { inputDto: action.institutionDto }
      }).pipe(
        map(({ data }: any) => {
          const result: any = Object.values(data)[0];

          if (result !== null && result?.response?.code === 9000){
            this.notificationService.successMessageAndCloseModals(result?.response?.message);

            if (action.institutionDto.actionType === ActionTypeEnum.delete){
              this.store.dispatch(deleteInstitution({id: action.id}));
              this.settingsService.reloadCurrentRoute(null);
            }
            this.store.dispatch(upsertInstitution({institution: result?.data}));

          }else {
            this.notificationService.errorMessage(result?.response?.message);
          }
        })
      );
    })
  ), { dispatch: false });

  constructor(
    private actions$: Actions,
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private apollo: Apollo,
    private settingsService: SettingsService,
  ) {
  }
}
